export default class GenericError {
  static GenericNotAuthorize = 'generic_not_authorize';

  static GenericErrorNotFound = 'generic_error_not_found';

  static GenericError = 'generic_error';
}
